import { helpers } from '@helpers';

import { DebugLocalStoragePage } from './components/DebugLocalStoragePage';
import { DeviceDebugPage } from './components/DeviceDebugPage';
import { LDLDebugPage } from './components/LDLDebugPage';
import { OnboardingDebugPage } from './components/OnboardingDebugPage';

export const DebugItems: DebugItemType[] = [
  {
    id: 'onboarding',
    pageID: 'OnboardingDebugPage',
    title: 'Onboarding',
    component: OnboardingDebugPage,
    type: 'button',
  },
  {
    id: 'device',
    pageID: 'DeviceDebugPage',
    title: 'Device',
    component: DeviceDebugPage,
    type: 'button',
  },
  {
    id: 'storage',
    pageID: 'DebugLocalStoragePage',
    title: 'Local Storage',
    component: DebugLocalStoragePage,
    type: 'button',
  },
  {
    id: 'ldl',
    pageID: 'LDLDebugPage',
    title: 'LDL',
    component: LDLDebugPage,
    type: 'button',
  },
  {
    id: 'enviroment',
    pageID: 'enviromentComp',
    title: 'Enviroment',
    component: null,
    type: 'switch',
    onPress: () => {},
    activeText: 'dev',
    inActiveText: 'prod',
    value: helpers.DEBUG,
  },
];

export type DebugItemType = {
  id: string;
  pageID: string;
  title: string;
  component: unknown;
  type: 'button' | 'switch';
  onPress?: () => void;
  activeText?: string;
  inActiveText?: string;
  value?: boolean;
};
